import { createSlice } from "@reduxjs/toolkit";
import {
    getAllRoleList
} from './thunk';

export const initialState = {
    rolesList: [],
    errors: {}
};

const DesignationSlice = createSlice({
    name: 'Role',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getAllRoleList.fulfilled, (state: any, action: any) => {
            state.rolesList = action.payload;
        });
        builder.addCase(getAllRoleList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
    }
});

export default DesignationSlice.reducer;